/** A prediction flight (experiment arm). */
export interface Flight {
  flight_id: string;
  name: string;
  is_control: boolean;
}

/** Flights for an experiment, from BigQuery. Shared by the report and the custom charts. */
export function buildFlightsSQL(experimentId: string): string {
  const safeId = Number(experimentId);
  if (!Number.isInteger(safeId)) throw new Error(`Invalid experiment id: ${experimentId}`);
  // status: HasStatus concern — exclude archived (2) flights.
  return `
    SELECT CAST(id AS STRING) AS flight_id, name, is_control
    FROM \`martin-test-datalab.postgres.prediction_flights\`
    WHERE global_experiment_id = ${safeId} AND status != 2
    ORDER BY is_control DESC, id
  `;
}
